module.exports = __webpack_public_path__ + "static/img/15.c002597.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/15.png
// module id = fIqK
// module chunks = 0